// extracted by mini-css-extract-plugin
module.exports = {"content":"IntegrationSettingsFooter_content___BVCi","doneButton":"IntegrationSettingsFooter_doneButton__SUjAB","deleteButton":"IntegrationSettingsFooter_deleteButton__iGdnA"};